module.exports = __webpack_public_path__ + "static/media/spot19.05735a96.webp";